// @flow
import React, { Component } from "react";
import { GlobalProvider } from "../common/GlobalContext";
import GlobalAlert from "../common/GlobalAlert";
import CoverPods from "./cover-pods/CoverPods";
import Pods from "./pods/Pods";

import type {
  $Agent,
  $BlogPosts,
  $Site,
  $SiteOffice,
  $SiteUser,
  $Team,
  ComplianceListingItems,
  $LocalListingViewModel,
  Testimonials,
  $ListingWidgets,
  $OpenHouses,
} from "flow/types";

type $Props = {
  BATHS_OPTIONS: Array<Object>,
  BEDS_OPTIONS: Array<Object>,
  CDN_IMAGE_SERVER_URL: string,
  PRICE_OPTIONS: Array<Object>,
  aboutLink: string,
  aboutPosts: $BlogPosts,
  agent: $Agent,
  alerts: Array<Object>,
  compliance: ComplianceListingItems,
  favorites: Object,
  featuredListings: $LocalListingViewModel[],
  featuredListingsHeader: string,
  listingWidgets: $ListingWidgets,
  office: $SiteOffice,
  posts: $BlogPosts,
  site: $Site,
  siteUser: $SiteUser,
  team: $Team,
  testimonials: Testimonials,
  theme: Object,
  widgetInfo: Array<Object>,
  homepageSearchHeroImage: string,
  homepageHeroImages: Array<string>,
  homepageFeaturedTownsHeroImage: string,
  openHouses: $OpenHouses,
  mlsApiVersion: number,
};

class Home extends Component<$Props> {
  render() {
    const {
      BATHS_OPTIONS,
      BEDS_OPTIONS,
      CDN_IMAGE_SERVER_URL,
      PRICE_OPTIONS,
      aboutLink,
      aboutPosts,
      agent,
      alerts,
      compliance,
      favorites,
      featuredListings,
      featuredListingsHeader,
      listingWidgets,
      office,
      posts,
      site,
      siteUser,
      team,
      testimonials,
      theme,
      widgetInfo,
      homepageSearchHeroImage,
      homepageHeroImages,
      homepageFeaturedTownsHeroImage,
      openHouses,
      mlsApiVersion,
    } = this.props;

    return (
      <GlobalProvider
        BATHS_OPTIONS={BATHS_OPTIONS}
        BEDS_OPTIONS={BEDS_OPTIONS}
        CDN_IMAGE_SERVER_URL={CDN_IMAGE_SERVER_URL}
        PRICE_OPTIONS={PRICE_OPTIONS}
        aboutLink={aboutLink}
        aboutPosts={aboutPosts}
        agent={agent}
        compliance={compliance}
        favorites={favorites}
        office={office}
        site={site}
        siteUser={siteUser}
        team={team}
        theme={theme}
        withStyleReset={false}
        openHouses={openHouses}
        mlsApiVersion={mlsApiVersion}
      >
        <GlobalAlert alerts={alerts} />
        <CoverPods
          homepageSearchHeroImage={homepageSearchHeroImage}
          homepageHeroImages={homepageHeroImages}
        />
        <Pods
          featuredListings={featuredListings}
          featuredListingsHeader={featuredListingsHeader}
          listingWidgets={listingWidgets}
          posts={posts}
          widgetInfo={widgetInfo}
          testimonials={testimonials}
          homepageFeaturedTownsHeroImage={homepageFeaturedTownsHeroImage}
        />
      </GlobalProvider>
    );
  }
}

export default Home;
